module.exports = __webpack_public_path__ + "img/green_069.51ca2673.png";